export const CACHE_NOTIFICATION = 'ADD_NOTIFICATION';
export const GET_ALL_ACTIVE_NOTIFICATION_TEMPLATES_INTO_STORE =
  'GET_ALL_ACTIVE_NOTIFICATION_TEMPLATES_INTO_STORE';
